import { API_URL } from './../../../../../actions/utilAction';
import { actionCreator,
    checkHttpStatus,
    create_post_data,
    createRequestActionTypes,
    createSearchUrl,
    extractDataFromObject,
    jsonApiHeader,
    showSuccessMessage,
    showErrorMessage
} from './../../../../../actions/utilAction';

export { jsonApiHeader,
    actionCreator,
    checkHttpStatus,
    createSearchUrl,
    create_post_data,
    showSuccessMessage,
    showErrorMessage,
    extractDataFromObject,
   API_URL,
};

export const GET_USER_ROLES_LIST_API = `${API_URL}/UserRole/GetRoles`;
export const POST_USER_ROLE_API = `${API_URL}/UserRole/SaveRole`;
export const GET_USER_ROLE_DETAILS_API = `${API_URL}/UserRole/GetRoleById`;
export const DELETE_USER_ROLE_API = `${API_URL}/UserRole/DeleteRole`;
export const COPY_USER_ROLE__API = `${API_URL}/UserRole/CopyUserRole`;

export const UserRoleActionTypes = {
  get_userRolesList: createRequestActionTypes('GET_USERROLESLIST'),
  post_userRole: createRequestActionTypes('POST_USERROLE'),
  get_userRoleDetails: createRequestActionTypes('GET_USERROLEDETAILS'),
  delete_userRole: createRequestActionTypes('DELETE_USERROLE'),
  copy_userRole:createRequestActionTypes(' COPY_USER_ROLE'),
};

export const MODULE = 'MASTER_USERROLES';





// WEBPACK FOOTER //
// ./src/modules/Masters/components/userRoles/constants/ApiConstants.js